<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "advance-payment",
  data() {
    return {};
  },
  created() {}
};
</script>
